var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionmarkGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32862_18268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58175 0 0 3.58175 0 8C0 12.4185 3.58175 16 8 16C12.4185 16 16.0003 12.4185 16.0003 8C16.0003 3.58175 12.4185 0 8 0ZM8 15.0157C4.14025 15.0157 1 11.8597 1 7.99997C1 4.14022 4.14025 0.999969 8 0.999969C11.8597 0.999969 15.0003 4.14023 15.0003 7.99997C15.0003 11.8597 11.8598 15.0157 8 15.0157ZM7.26475 12.5075H8.52275V11.238H7.26475V12.5075ZM7.98525 3.49273C7.25275 3.49273 6.64926 3.69023 6.17526 4.08475C5.70127 4.47948 5.47077 5.26998 5.48252 5.92498L5.50102 5.96148H6.64851C6.64851 5.57073 6.77876 5.00923 7.03926 4.80773C7.29951 4.60648 7.61501 4.50573 7.98551 4.50573C8.41251 4.50573 8.74076 4.62173 8.97103 4.85372C9.20103 5.08572 9.31576 5.41747 9.31576 5.84847C9.31576 6.21072 9.23076 6.51997 9.06001 6.77622C8.88876 7.03247 8.60176 7.39873 8.19926 7.875C7.78401 8.24948 7.52751 8.55048 7.43001 8.77823C7.33226 9.00623 7.28151 9.41523 7.27776 10.005H8.48026C8.48026 9.63498 8.50375 9.36223 8.55051 9.18723C8.597 9.01248 8.73026 8.815 8.95002 8.59523C9.42227 8.13973 9.80151 7.69423 10.0888 7.2585C10.3753 6.82323 10.5188 6.34298 10.5188 5.81798C10.5188 5.08548 10.2973 4.51473 9.8535 4.10598C9.4095 3.69698 8.78675 3.49273 7.98525 3.49273Z",
    fill: "#16BAB6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32862_18268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkGreen);
export default __webpack_public_path__ + "static/media/questionmark_green.62d5f2e7.svg";
export { ForwardRef as ReactComponent };